
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import apiInstance from '../utils/apiInstance';
import ViewDetails from '../common/ViewDetails';
const ViewWaiter = () => {
    const { _id } = useParams();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        async function fetchData() {
            setLoading(true)
            try {
                const response = await apiInstance.get(`/viewWaiter/${_id}`);
                setData(response.data.waiterDetails);
            } catch (error) {
                setError("An error occurred while fetching waiter details...");
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, [_id]);

    if (error) return <div>{error}<br />Please try again after some time or check your internet connection.</div>

    return (
        <>
            <ViewDetails
                waiter='waiter'
                heading='Waiter Details'
                data={data}
                loading={loading}
                error={error}
            />
        </>
    );
}

export default ViewWaiter;